export const videosKey = {
  getAllVideos: (page: string | undefined, pageLimit: string | undefined, title?: string, tags?: string) =>
    ['Videos', 'GetAllVideos', page, pageLimit, title, tags] as const,
};
